module.exports = __webpack_public_path__ + "img/4.1272475b.png";